import type { InstanceConfig } from "../../src/instance.js";

/**
 * Internal ops instance — the hub tier (kernel-free ui-core shell) over the same
 * AI-governance descriptors. An example of the second blessed tier (ADR-001 §7):
 * same kit, same data, a lightweight internal surface with no auth gate or
 * assistant chrome. Built with `npm run dev -- --mode ops` (.env.ops).
 */
const config: InstanceConfig = {
  name: "ops",
  tier: "hub",
  brand: "AI Governance — Ops",
};

export default config;
